import "../utils/calendar.mjs";
import { css as e, styled as t } from "styled-components";
//#region src/components/DatePicker/styled/CalendarMonth.styled.ts
var n = t.div`
    width: ${({ $fluid: e }) => e ? "100%" : "280px"};
    flex-shrink: 0;
    user-select: none;
`, r = t.div`
    display: grid;
    grid-template-columns: repeat(7, ${40}px);
    row-gap: 2px;
`, i = t(r)`
    grid-template-columns: repeat(7, 1fr) !important;

    /* Override fixed cell widths set on Day/DayLabel — !important needed
       to beat the styled-component class specificity on Day */
    & > * {
        width: 100% !important;
    }
`, a = t.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${({ theme: e }) => e.spacing(1.5)};
    width: 100%;
`, o = t.div`
    visibility: ${({ $hidden: e }) => e ? "hidden" : "visible"};
`, s = t.button`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    cursor: pointer;
    padding: ${({ theme: e }) => e.spacing(.5, 1)};
    border-radius: ${({ theme: e }) => e.radii.sm};
    color: ${({ theme: e }) => e.colors.foreground};
    transition: background ${({ theme: e }) => e.transitions.fast};
    &:hover {
        background: ${({ theme: e }) => e.colors.accent};
    }
`, c = t.div`
    width: 100%;
`, l = t.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${({ theme: e }) => e.spacing(1.5)};
`, u = t.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${({ theme: e }) => e.spacing(1)};
`, d = t.button`
    padding: ${({ theme: e }) => e.spacing(1.25, 1)};
    border: 1px solid ${({ theme: e, $sel: t }) => t ? e.colors.primary : e.colors.border};
    background: ${({ theme: e, $sel: t }) => t ? e.colors.primary + "11" : e.colors.card};
    color: ${({ theme: e }) => e.colors.foreground};
    border-radius: ${({ theme: e }) => e.radii.md};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    cursor: pointer;
    transition:
        background ${({ theme: e }) => e.transitions.fast},
        border-color ${({ theme: e }) => e.transitions.fast};
    &:hover {
        border-color: ${({ theme: e }) => e.colors.primary};
        background: ${({ theme: e }) => e.colors.accent};
    }
`, f = t.span`
    width: ${40}px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme: e }) => e.colors.mutedForeground};
`, p = t.button`
    width: ${40}px;
    height: ${({ $hasAnnotation: e }) => e ? "48px" : "40px"};
    border: none;
    background: transparent;
    border-radius: ${({ theme: e }) => e.radii.md};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    cursor: ${({ $off: e }) => e ? "not-allowed" : "pointer"};
    transition:
        background ${({ theme: e }) => e.transitions.fast},
        color ${({ theme: e }) => e.transitions.fast};
    position: relative;
    overflow: visible;
    z-index: 0;

    /* Flex column layout for annotated cells */
    ${({ $hasAnnotation: t }) => t && e`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 1px;
        `}

    /* default text colour */
    color: ${({ theme: e, $outside: t, $off: n }) => t || n ? e.colors.mutedForeground : e.colors.foreground};
    opacity: ${({ $off: e }) => e ? .4 : 1};

    /* blocked date — diagonal strikethrough */
    ${({ $blocked: t }) => t && e`
            &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 15%;
                width: 70%;
                height: 1.5px;
                background: currentColor;
                opacity: 0.5;
                transform: rotate(-45deg);
                pointer-events: none;
                z-index: 2;
            }
        `}

    /* Range strip: a continuous background behind the cells. */
    /* A ::before pseudo-element creates a seamless highlighted strip
       across the entire selected range. */
    ${({ $inRange: t, $start: n, $end: r, theme: i }) => (t || n || r) && e`
            overflow: visible;
            &::before {
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                left: ${n ? "50%" : "0"};
                right: ${r ? "50%" : "0"};
                background: ${i.colors.primary}15;
                z-index: -1;
            }
        `}

    /* When start === end (single day selected), hide the strip */
    ${({ $start: t, $end: n }) => t && n && e`
            &::before {
                display: none;
            }
        `}

    /* range start / end caps — pill shape with inner content circle */
    ${({ $start: t, $end: n, theme: r }) => (t || n) && e`
            background: ${r.colors.primary};
            color: ${r.colors.primaryForeground};
            border-radius: ${t && n ? r.radii.md : `${r.radii.md} ${r.radii.md} ${r.radii.md} ${r.radii.md}`};
            font-weight: ${r.typographyTokens.weights.semibold};
            z-index: 1;
        `}

    /* in-range (between start/end, not the caps themselves) */
    ${({ $inRange: t, $start: n, $end: r, theme: i }) => t && !n && !r && e`
            background: ${i.colors.primary}15;
            color: ${i.colors.foreground};
            border-radius: 0;
        `}

    /* single selected */
    ${({ $sel: t, $start: n, $end: r, theme: i }) => t && !n && !r && e`
            background: ${i.colors.primary};
            color: ${i.colors.primaryForeground};
            font-weight: ${i.typographyTokens.weights.semibold};
        `}

    /* today ring */
    ${({ $today: t, $sel: n, $start: r, $end: i, theme: a }) => t && !n && !r && !i && e`
            outline: 1.5px solid ${a.colors.primary};
            outline-offset: -1.5px;
            color: ${a.colors.primary};
            font-weight: ${a.typographyTokens.weights.semibold};
        `}

    /* hover */
    ${({ $off: t, $sel: n, $start: r, $end: i, theme: a }) => !t && !n && !r && !i && e`
            &:hover {
                background: ${a.colors.accent};
                color: ${a.colors.foreground};
                border-radius: ${a.radii.md};
            }
        `}

    /* Hovered cell must paint above neighbours so its tooltip isn't clipped
       by the range-start/end caps (which have z-index: 1). */
    &:hover {
        z-index: 10;
    }
`, m = t.span`
    font-size: 9px;
    line-height: 1;
    white-space: nowrap;
    /* Inherit parent color so it switches to white when the day is selected */
    color: ${({ theme: e, $variant: t }) => t === "highlight" ? e.colors.success : t === "muted" ? e.colors.mutedForeground : "inherit"};
`, h = t.span`
    position: absolute;
    bottom: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
    padding: 3px 8px;
    border-radius: ${({ theme: e }) => e.radii.sm};
    background: ${({ theme: e }) => e.colors.foreground};
    color: ${({ theme: e }) => e.colors.background};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: 11px;
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    line-height: 1.3;
    white-space: nowrap;
    pointer-events: none;
    z-index: 20;
    opacity: 0;
    transition: opacity 150ms ease;

    /* Arrow */
    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 4px solid transparent;
        border-top-color: ${({ theme: e }) => e.colors.foreground};
    }

    /* Show on parent hover */
    ${p}:hover & {
        opacity: 1;
    }
`;
//#endregion
export { r as CalGrid, n as CalMonth, a as CalNav, p as Day, m as DayAnnotationLabel, f as DayLabel, h as DayTooltip, i as FluidCalGrid, d as MonthCell, u as MonthGrid, o as NavArrowWrap, c as PickerPanel, s as TitleButton, l as YearNav };
